export default function ImgGallery() {
  const mainElement = document.getElementById(`js_img_gallery`);
  if (mainElement) {
    const links = [...mainElement.querySelectorAll(`.detail-selective-link`)];
    const imgLists = [...mainElement.querySelectorAll(`.detail-selective-img`)];
    const changeImgButton = mainElement.querySelector(`.detail-showarea`);
    const changeImgElement = mainElement.querySelector(
      `.detail-showarea > img`
    );
    addCurrentClass(links, 0);
    imgLists.forEach((imgItem, index, _array) => {
      imgItem.addEventListener(`click`, _event => {
        changeImgElement.src = imgItem.src;
        changeImgElement.dataset.number = index + 1;
        addCurrentClass(links, index);
      });
    });

    changeImgButton.addEventListener(`click`, _event => {
      const currentStatus = +changeImgElement.dataset.number;
      const nextStatus = currentStatus + 1;
      if (nextStatus <= imgLists.length - 1) {
        changeImgElement.src = imgLists[nextStatus].src;
        changeImgElement.dataset.number = nextStatus;
        addCurrentClass(links, nextStatus);
      } else {
        changeImgElement.src = imgLists[0].src;
        changeImgElement.dataset.number = 0;
        addCurrentClass(links, 0);
      }
    });
  }
  function addCurrentClass(links, index) {
    links.map(x => x.classList.remove(`is-current`));
    links[index].classList.add(`is-current`);
    const listElement = document.querySelectorAll(".detail-selective-list");
    const paginationElement = document.getElementById("paginationElement");

    if (listElement.length < 10) {
      paginationElement.style.display = "none";
    }
  }
}
